import React from 'react'
import ContentPage from '../components/ContentPage'

const Bio = () => <ContentPage pageTitle='Bio' docID='bio' />

export default Bio
